import React from 'react';
import { FaInstagram } from '@react-icons/all-files/fa/FaInstagram';
import { FaFacebookSquare } from '@react-icons/all-files/fa/FaFacebookSquare';
import { IoLogoTiktok } from '@react-icons/all-files/io5/IoLogoTiktok';
import { FaLinkedin } from '@react-icons/all-files/fa/FaLinkedin';
import { FaWikipediaW } from '@react-icons/all-files/fa/FaWikipediaW';
import { FaGlobeAmericas } from '@react-icons/all-files/fa/FaGlobeAmericas';
import { FaRegEnvelope } from '@react-icons/all-files/fa/FaRegEnvelope';
import TwitterIcon from '~images/icons/twitter';

const socialIcons = {
  facebook: <FaFacebookSquare title="Facebook Icon" />,
  instagram: <FaInstagram title="Instagram Icon" />,
  linkedin: <FaLinkedin title="Linkedin Icon" />,
  twitter: <TwitterIcon />,
  tiktok: <IoLogoTiktok title="Tiktok Icon" />,
  wikipedia: <FaWikipediaW title="Wikipedia" />,
  website: <FaGlobeAmericas title="Website" />,
  message: <FaRegEnvelope title="Envelope icon" />,
};

export default (author) => [
  { id: 'fb', link: author?.facebook_profile, icon: socialIcons?.facebook },
  { id: 'ig', link: author?.instagram_profile, icon: socialIcons?.instagram },
  { id: 'li', link: author?.linkedin_profile, icon: socialIcons?.linkedin },
  { id: 'tw', link: author?.twitter_profile, icon: socialIcons?.twitter },
  { id: 'tt', link: author?.tik_tok, icon: socialIcons?.tiktok },
  { id: 'ws', link: author?.personal_website, icon: socialIcons?.website },
  { id: 'em', link: author?.email_address, icon: socialIcons?.message },
];
